import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AllRoutes from "./pages/routes/AppRoutes";
import "./assets/resposive.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { APP_URL } from "./shared/baseUrl";

function App() {
  const settingsData = useSelector((state) => state?.settingData.settingDatas);
  const primaryColor = settingsData?.find(
    (item) => item?.key_name === "PRIMARY_COLOR"
  )?.key_value;
  const secondryColor = settingsData?.find(
    (item) => item?.key_name === "SECONDARY_COLOR"
  )?.key_value;
  const darkColor = settingsData?.find(
    (item) => item?.key_name === "DARK_COLOR"
  )?.key_value;
  const lightColor = settingsData?.find(
    (item) => item?.key_name === "LIGHT_COLOR"
  )?.key_value;
  const siteName = settingsData?.find(
    (item) => item?.key_name === "SITE_NAME"
  )?.key_value;
  const sitelogo = settingsData?.find(
    (item) => item?.key_name === "SITE_LOGO"
  )?.key_value;
  const siteFavIcon = settingsData?.find((item)=> item?.key_name === "FAV_ICON")?.key_value
  const fontSetting =  settingsData?.find(
    (item) => item?.key_name === "FONT FAMILY"
  )?.key_value;
   let font = fontSetting ? JSON.parse(fontSetting) :""
  useEffect(() => {
    if (siteName) {
      document.title = siteName;
    }
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    const faviconUrl = APP_URL + siteFavIcon;    
    link.href = faviconUrl;
    const root = document.documentElement;
    root.style.setProperty("--primary-color-gentlemenz", primaryColor);
    root.style.setProperty("--secondry-color-gentlemenz", secondryColor);
    root.style.setProperty("--hover-color-gentlemenz", darkColor);
    root.style.setProperty("--primary-light-color-gentlemenz", lightColor);
  }, [settingsData]);

  useEffect(() => {
    if (font) {
      const link = document.createElement("link");
      link.href = font?.fontCDN;
      link.rel = "stylesheet";
      document.head.appendChild(link);
      document.body.style.fontFamily = `"${font?.fontFamily}", sans-serif`;
      return () => {
        document.head.removeChild(link);
      };
    }
  }, [font]);

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        toastStyle={{
          fontSize: "15px",
          fontWeight: "bold",
          color: "var(--default-bg-color)",
          backgroundColor: "var(--primary-color-gentlemenz)",
          borderRadius: "5px",
          padding: "10px",
          width: "300px",
          maxWidth: "100%",
          textAlign: "center",
          height: "80px",
          minHeight: "80px",
        }}
        toastClassName="custom-toast"
      />

      <AllRoutes />
    </div>
  );
}

export default App;
